<template>
  <div class="contain">
    <div class="logo"></div>
    <span class="logoText"> 数字三一 · 智造未来</span>
    <div class="weatherMsg" title="数据来源：心知天气" v-show="showWeather">
      <span class="weatherAddress">{{ address }}</span>
      <span :class="weatherClass"> </span>
      <span class="weatherTemp">{{ now.temperature }} ℃</span>
      <span class="weatherText">{{ now.text }}</span>
    </div>
    <span class="dateText">{{ dateText }}</span>
    <span class="userText">{{ userText }}</span>
    <div class="exitImg" @click="toExit"></div>
    <span class="tab_1">首页</span>
    <span class="tab_3" @click="toTransfer">工程中心</span>
    <span class="tab_4" @click="toEquipment">设备中心</span>
    <!-- <span class="tab_4" @click="toApplication">应用中心</span> -->
    <span class="tab_5" @click="toSystem">系统设置</span>
    <!-- <span class="line_1"></span> -->
    <span class="line_2"></span>
    <span class="line_3"></span>
    <!-- <el-dropdown id="mainPageSwitch" @command="handleCommand">
      <el-button type="primary">
        {{ currentPageName }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-show="deviceVisible" command="a"
          >设备</el-dropdown-item
        >
        <el-dropdown-item v-show="monitorVisible" command="b"
          >现场监控</el-dropdown-item
        >
        <el-dropdown-item v-show="projectVisible" command="c"
          >工程</el-dropdown-item
        >
        <el-dropdown-item v-show="pavVisible" command="d"
          >设备评估</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
import { dateFormat } from "../../utils/commons";
import CryptoJS from "crypto-js/crypto-js";
import $ from "jquery";
export default {
  name: "app",
  data() {
    return {
      dateText: "",
      userText: localStorage.getItem("userName"),
      deviceVisible: true,
      monitorVisible: true,
      projectVisible: false,
      pavVisible: true,
      currentPageName: "工程",
      address: "",
      now: {},
      showWeather: false,
      currentProject : ""
    };
  },
  computed: {
    weatherClass: function () {
      if (this.now != {}) {
        return "weatherIcon weatherIcon" + this.now.code;
      } else {
        return "";
      }
    },
  },
  mounted() {
    var now = new Date();
    this.dateText = dateFormat(now, "YYYY年MM月DD日");
    this.getWeather();
  },
  methods: {
    toTransfer: function () {
      this.$router.push({ name: "EngineeringCenter" });
    },
    toEquipment: function () {
      this.$router.push({ name: "EquipmentCenter" });
    },
    toSystem: function () {
      this.$router.push({ name: "Person" });
    },
    toExit: function () {
      this.$router.push({ name: "Login" });
    },
    toApplication: function () {
      this.$router.push({ name: "Application" });
    },
    handleCommand(command) {
      if (command == "a") {
        //设备
        this.$router.push({ name: "DevicePage" });
      } else if (command == "b") {
        //现场监控
        this.$router.push({ name: "HomePageZ" });
      } else if (command == "c") {
        //工程
        this.$router.push({ name: "HomePage" });
      } else if (command == "d") {
        //工程
        this.$router.push({ name: "PavPage" });
      }
    },
    getWeather() {
      //获取地址，然后对天气进行获取
      let address = window.localStorage.getItem("LJSZH_ADDRESS");

      let d = new Date();

      let currentDate = d.getDate();

      let currentHour = d.getHours();

      let weatherTime = window.localStorage.getItem("LJSZH_weather_time");

      let weatherDataJSON = window.localStorage.getItem("LZSZH_weather_data");

      let dayHour = currentHour + "" + currentDate;

      if (address == null || address == undefined || address == "") {
        this.showWeather = false;

        return;
      } else {
        this.address = address;
      }

      if (weatherTime && dayHour == weatherTime && weatherDataJSON) {
        //一小时内已获取过天气数据

        let weatherData = JSON.parse(weatherDataJSON);

        this.now = weatherData;
        this.showWeather = true;
        return;
      }

      let that = this;

      // if (address) {
      //   var UID = "PcF5oaYTw9JLZzYQe";
      //   var ts = Math.round(new Date().getTime() / 1000);
      //   var str = "ts=" + ts + "&ttl=600&uid=" + UID;
      //   var sig = CryptoJS.HmacSHA1(str, "ScDHmP8BWEribjjBO").toString(
      //     CryptoJS.enc.Base64
      //   );
      //   sig = encodeURIComponent(sig);
      //   str = str + "&sig=" + sig;
      //   var url2 =
      //     "https://api.seniverse.com/v3/weather/now.json?location=" +
      //     address +
      //     "&" +
      //     str;

      //   $.ajax({
      //     url: url2,
      //     type: "get",
      //     cache: "false",
      //     dataType: "jsonp",
      //     jsonp: "callback",
      //     jsonpCallback: "showWeather",
      //     success: function (res) {
      //       that.showWeather = true;
      //       let results = res.results;
      //       if (results && results.length > 0) {
      //         let result = results[0];
      //         that.now = result.now;
      //         window.localStorage.setItem("LJSZH_weather_time", dayHour);
      //         window.localStorage.setItem(
      //           "LZSZH_weather_data",
      //           JSON.stringify(result.now)
      //         );
      //       }
      //     },
      //     error: function (res) {
      //       console.log(res);
      //     },
      //   });


      if (address) {
        var UID = "ST6tpDw2o24jhrx1O";
        // var ts = Math.round(new Date().getTime() / 1000);
        var str = "&language=zh-Hans&unit=c";
        var sig = CryptoJS.HmacSHA1(str, "ScDHmP8BWEribjjBO").toString(
          CryptoJS.enc.Base64
        );
        sig = encodeURIComponent(sig);
        str = str + "&sig=" + sig;
        var url2 =
          "https://api.seniverse.com/v3/weather/now.json?key=" +
          UID + "&" +
          "location=" + address +
          str;

        $.ajax({
          url: url2,
          type: "get",
          cache: "false",
          dataType: "json",
          success: function (res) { //eslint-disable-line no-unused-vars
            that.showWeather = true;
            let results = res.results;
            if (results && results.length > 0) {
              let result = results[0];
              that.now = result.now;
              window.localStorage.setItem("LJSZH_weather_time", dayHour);
              window.localStorage.setItem(
                "LZSZH_weather_data",
                JSON.stringify(result.now)
              );
            }
          },
          error: function (res) {
            // console.log(res);
          },
        });

      }
    },

  },
  components: {},
};
</script>
<style lang='scss'>
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: #9db4de;
  color: #1c6dfe;
}
#mainPageSwitch{
  span{
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
}
</style>
<style lang="scss" scoped="">

.weatherMsg {
  width: 100px;
  height: 42px;
  line-height: 50px;
  background: transparent;
  position: absolute;
  right: 15.625vw;
  font-size: 14px;
  .weatherIcon {
    height: 24px;
    width: 24px;
    background-repeat: no-repeat;
    background-size: 24px 24px;
    position: absolute;
    top: 10px;
  }
  .weatherTemp {
    top: -2px;
    font-size: 14px;
    color: white;
    position: absolute;
    left: 30px;
  }
  .weatherText {
    top: -2px;
    font-size: 14px;
    color: white;
    position: absolute;
    left: 70px;
  }
  span {
    font-size: 14px;
  }
  .weatherIconundefined {
    background-image: url(../../images/weather/99@1x.png);
    background-size: 100% 100%;
  }
  @for $i from 0 through 38 {
    .weatherIcon#{$i} {
      background-image: url("../../images/weather/#{$i}@1x.png");
      background-size: 100% 100%;
    }
  }
  .weatherIcon99 {
    background-image: url(../../images/weather/99@1x.png);
    background-size: 100% 100%;
  }
  .weatherAddress {
    top: -2px;
    position: absolute;
    left: -60px;
    color: white;
  }
}

.contain {
  height: 100%;
  width: 100%;
  background-image: url("../../images/all/header.png");
  background-size: 100% 100%;
  position: relative;
  .logo {
    width: 86px;
    height: 22px;
    position: absolute;
    top: 11px;
    left: 39px;
    background-image: url("../../images/all/logo.png");
    background-size: 100% 100%;
  }
  .logoText {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    position: absolute;
    line-height: 14px;
    top: 15px;
    left: 150px;
  }
  .dateText {
    display: inline-block;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    line-height: 14px;
    top: 15px;
    right: 170px;
  }
  .userText {
    display: inline-block;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    line-height: 14px;
    top: 15px;
    right: 71px;
  }
  .exitImg {
    height: 18px;
    width: 18px;
    position: absolute;
    top: 14px;
    right: 42px;
    background-image: url("../../images/all/exit.png");
    background-size: 100% 100%;
    cursor: pointer;
  }
  .line_1 {
    position: absolute;
    width: 1px;
    height: 14px;
    background: #0a89ff;
    top: 63px;
    left: 322px;
  }
  .line_2 {
    position: absolute;
    width: 1px;
    height: 14px;
    background: #0a89ff;
    top: 58px;
    left: 435px;
  }
  .line_3 {
    position: absolute;
    width: 1px;
    height: 14px;
    background: #0a89ff;
    top: 58px;
    left: 1474px;
  }
  .tab_1 {
    position: absolute;
    display: inline-block;
    color: #ffffff;
    padding: 9px 19px;
    background: #1c6dfe;
    border-radius: 16px;
    top: 48px;
    left: 350px;
    line-height: 15px;
    font-size: 15px;
    cursor: pointer;
  }
  .tab_2 {
    position: absolute;
    display: inline-block;
    color: #ffffff;
    line-height: 15px;
    font-size: 15px;
    top: 63px;
    left: 346px;
    cursor: pointer;
  }
  .tab_3 {
    position: absolute;
    display: inline-block;
    color: #ffffff;
    line-height: 15px;
    font-size: 15px;
    top: 58px;
    left: 464px;
    cursor: pointer;
  }
  .tab_4 {
    position: absolute;
    display: inline-block;
    color: #ffffff;
    line-height: 15px;
    font-size: 15px;
    top: 58px;
    left: 1381px;
    cursor: pointer;
  }
  .tab_5 {
    position: absolute;
    display: inline-block;
    color: #ffffff;
    line-height: 15px;
    font-size: 15px;
    top: 58px;
    left: 1509px;
    cursor: pointer;
  }
  #mainPageSwitch {
    position: absolute;
    top: 54px;
    left: 1750px;
    button {
      display: inline-block;
      color: #ffffff;
      padding: 0px 19px !important;
      background: #1c6dfe;
      border-color: #1c6dfe;
      border-radius: 16px !important;
      line-height: 32px;
      height: 32px !important;
      font-size: 15px !important;
      cursor: pointer;
    }
  }
}
</style>